import type { PublicSlotKey } from '#packages/apilib';
import type { WixStoreApi } from './wixStoreApi';

export const WixStoreApiKey: PublicSlotKey<WixStoreApi> = {
  name: 'WixStoreApiKey',
  public: true,
};
